import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppAccountRemovalPage } from './app-account-removal';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppAccountRemovalPage,
  ],
  imports: [
    IonicPageModule.forChild(AppAccountRemovalPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppAccountRemovalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-account-removal/app-account-removal.module.ts